import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Building2, Plus, UserPlus, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { can } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

export default function QuickAdd() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const loc = useLocation();

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, []);

  if (!can(user, "leads") || loc.pathname === "/chat") return null;
  const actions = [
    { label: "Add lead", icon: UserPlus, to: "/leads/new", testid: "quick-add-lead-option" },
    { label: "Add property", icon: Building2, to: "/properties/new", testid: "quick-add-property-option" },
  ];
  return (
    <div ref={ref} className="fixed bottom-20 right-4 z-40 flex flex-col items-end gap-3 md:bottom-8 md:right-8">
      {open &&
        actions.map((a, i) => (
          <button
            key={a.to}
            data-testid={a.testid}
            onClick={() => {
              setOpen(false);
              nav(a.to);
            }}
            style={{ animationDelay: `${i * 40}ms` }}
            className="fade-up flex items-center gap-2 rounded-full border bg-card py-2 pl-3 pr-4 text-sm font-semibold shadow-lg transition-colors hover:bg-secondary"
          >
            <a.icon className="h-4 w-4 text-primary" />
            {a.label}
          </button>
        ))}
      <button
        data-testid="quick-add-fab-button"
        onClick={() => setOpen((o) => !o)}
        aria-label="Quick add"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-xl shadow-primary/30 transition-transform active:scale-95"
      >
        {open ? <X className="h-6 w-6" /> : <Plus className={cn("h-6 w-6")} />}
      </button>
    </div>
  );
}
